<h2>Branding</h2>
<div [formGroup]="branding">
  <div *ngIf="INCLUDE_COLORS">

    <h3>Colours</h3>
    <p>The primary and secondary colour is used as gradient where images are loading or missing.</p>
    <p>You can select white for both colours if you would prefer to not show colour.</p>
    <form (submit)="onSubmitColors()"
      formGroupName="colors">
      <label>Primary</label>
      <input [colorPicker]="primary"
        (colorPickerChange)="primary = $event"
        [style.backgroundColor]="primary" />
      <label>Secondary</label>
      <input [colorPicker]="secondary"
        (colorPickerChange)="secondary = $event"
        [style.backgroundColor]="secondary" />
      <button color="primary"
        (click)="resetColors()"
        type="button"
        mat-flat-button
        color="warn">Reset</button>
      <button (click)="onSubmitColors()"
        color="primary"
        mat-flat-button>Save</button>
    </form>
  </div>
  <h3>Images</h3>
  <form formGroupName="media">
    <div *ngIf="INCLUDE_PLACEHOLDER">

      <h4>Message Placeholder Logo</h4>
      <p>This image is used on message cards for messages without photos. Image should be at least 300 pixels wide,
        rectangular images work best.</p>
      <ca-photo-picker class="memoLogo"
        formControlName="memoBannerImage"
        title="Memo Banner Image"></ca-photo-picker>
      <button color="primary"
        (click)="resetImage('memoBannerImage')"
        type="button"
        mat-flat-button
        color="warn">Reset</button>
      <button (click)="onImageSubmitted('memoBannerImage')"
        color="primary"
        mat-flat-button>Save</button>
    </div>
    <h4>Menu Background Image</h4>
    <p>Image should be 600x350px</p>
    <ca-photo-picker class="background"
      formControlName="menuBackgroundImage"
      title="Menu Background Image"></ca-photo-picker>
    <button color="primary"
      (click)="resetImage('menuBackgroundImage')"
      type="button"
      mat-flat-button
      color="warn">Reset</button>
    <button (click)="onImageSubmitted('menuBackgroundImage')"
      color="primary"
      mat-flat-button>Save Menu Background</button>
    <h4>Menu Icon</h4>
    <p>Image should be 100x100px</p>
    <ca-photo-picker class="icon"
      formControlName="logoIcon"
      title="Menu Icon"></ca-photo-picker>
    <button color="primary"
      (click)="resetImage('logoIcon')"
      type="button"
      mat-flat-button
      color="warn">Reset</button>
    <button (click)="onImageSubmitted('logoIcon')"
      color="primary"
      mat-flat-button>Save Icon</button>
  </form>
</div>